import axios from 'axios';

// Variables para manejar el refresh de tokens
let isRefreshing = false;
let queue = [];

const redirectToLogin = () => {
  try {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('currentUser');
  } catch (e) {
    console.error('Error al limpiar la sesión:', e);
  }

  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
};


const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://192.168.1.10:3001/api',
  withCredentials: true, 
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor de Request: Agregar token Bearer automáticamente
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function attachNormalizedError(error) {
  try {
    const res = error?.response;
    const data = res?.data;
    error.__normalized = {
      status: res?.status,
      code: data?.error?.code ?? data?.code,
      message: data?.error?.message ?? data?.message ?? error.message,
      details: data?.error?.details ?? data?.details,
    };
  } catch {
    error.__normalized = { message: error?.message || 'Error' };
  }
  return error;
}

const getRefreshToken = () => {
  return 
         // localStorage.getItem('accessToken') ||
         localStorage.getItem('refreshToken') || 
         localStorage.getItem('refresh_token') ||
         sessionStorage.getItem('refreshToken') ||
         sessionStorage.getItem('refresh_token');
};

// Interceptor de Response: Manejar errores globalmente
http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error?.response?.status;
    
    // Definir qué rutas son de autenticación (ajusta según tus rutas)
    const isAuthPath = (path) => {
      if (!path) return false;
      return path.includes('/auth/login') || 
             path.includes('/auth/refresh') ||
             path.includes('/admin/user/login') || 
             path.includes('/admin/user/refresh');
    };

    // Si es error 401 y no es una ruta de auth y no se ha reintentado
    if (status === 401 && !original._retry && !isAuthPath(original.url)) {
      original._retry = true;
      
      // Obtener refresh token
      const refreshToken = getRefreshToken();
      
      if (!refreshToken) {
        // No hay refresh token, redirigir al login
        redirectToLogin();
        attachNormalizedError(error);
        return Promise.reject(error);
      }

      if (!isRefreshing) {
        isRefreshing = true;
        try {
          // Hacer la solicitud de refresh con el token
          const { data } = await http.post('/admin/user/refresh', {
            refreshToken: refreshToken
          });
          
          // Guardar nuevos tokens (ajusta según la estructura de respuesta)
          const newAccessToken = data.accessToken || data.token;
          const newRefreshToken = data.refreshToken;
          
          if (newAccessToken) {
            localStorage.setItem('accessToken', newAccessToken);
          }
          if (newRefreshToken) {
            localStorage.setItem('refreshToken', newRefreshToken);
          }
          
          // Ejecutar todas las solicitudes en cola con el nuevo token
          queue.forEach((cb) => cb(newAccessToken));
          queue = [];
          
          // Retry de la solicitud original
          original.headers.Authorization = `Bearer ${newAccessToken}`;
          return http(original);
          
        } catch (refreshError) {
          console.error('Refresh token failed:', refreshError);
          
          // Limpiar sesión
          clearTokens();
          queue = [];
          isRefreshing = false;
          
          // Redirigir al login
          redirectToLogin();
          
          attachNormalizedError(error);
          return Promise.reject(error);
        } finally {
          isRefreshing = false;
        }
      }

      // Si ya se está refrescando, poner en cola la solicitud
      return new Promise((resolve) => {
        queue.push((newToken) => {
          original.headers = original.headers || {};
          original.headers.Authorization = `Bearer ${newToken}`;
          resolve(http(original));
        });
      });
    }

    // Si es error 401 en ruta no-auth (sin reintento disponible)
    if (status === 401 && !isAuthPath(original.url)) {
      redirectToLogin();
    }

    attachNormalizedError(error);
    return Promise.reject(error);
  }
);

export default http;

